import { useEffect, useState } from "react"
import { Capacitor } from "@capacitor/core"
import { App } from "@capacitor/app"

interface AppVersion {
    version: string
    build: string
}

export const useAppVersion = (): AppVersion | null => {
    const [version, setVersion] = useState<AppVersion | null>(null)

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return
        App.getInfo()
            .then(info => {
                setVersion({ version: info.version, build: info.build })
            })
            .catch(error => {
                console.error("[AppVersion] Failed to get app info:", error)
            })
    }, [])

    return version
}
